import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import Decimal from 'decimal.js';
var SCIENTIFIC_NOTATION_REGEX = /^\s*(-?\d+(?:\.\d+)?)\s*\*\s*10\s*\^\s*(-?\d+)\s*$/;
var SCIENTIFIC_E_NOTATION_REGEX = /^([-+]?\d+(?:\.\d+)?)[eE]([-+]?\d+)$/;
var SCIENTIFIC_NOTATION = 'SCIENTIFIC_NOTATION';
var SCIENTIFIC_E_NOTATION = 'SCIENTIFIC_E_NOTATION';
export function formatScientificNotation(mantissa, exponent) {
  var notation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var formatted;
  if (notation === SCIENTIFIC_E_NOTATION) {
    formatted = "".concat(mantissa, "e").concat(exponent);
    if (!SCIENTIFIC_E_NOTATION_REGEX.test(formatted)) {
      throw new Error("Not a valid number in scientific E notation: '".concat(formatted, "'"));
    }
  } else {
    formatted = "".concat(mantissa, "*10^").concat(exponent);
    if (!isScientificNotation(formatted)) {
      throw new Error("Not a valid number in scientific notation: '".concat(formatted, "'"));
    }
  }
  return formatted;
}
export function isScientificNotation(value) {
  return SCIENTIFIC_NOTATION_REGEX.test(value);
}
export function getScientificNotation(value) {
  if (SCIENTIFIC_NOTATION_REGEX.test(value)) return SCIENTIFIC_NOTATION;
  if (SCIENTIFIC_E_NOTATION_REGEX.test(clean(value))) return SCIENTIFIC_E_NOTATION;
  return null;
}
export function parseScientificNotation(value) {
  var strValue = value.toString();
  var match = strValue.match(SCIENTIFIC_NOTATION_REGEX) || clean(strValue).match(SCIENTIFIC_E_NOTATION_REGEX);
  if (!match) {
    throw new Error("Not a valid number in scientific notation: '".concat(strValue, "'"));
  }
  return match.slice(1);
}
export function normalizeScientificNotation(value) {
  var decimal = scientificNotationToDecimal(value);
  var match = decimal.toExponential().match(/^(.+)e\+?(.+)$/);
  return formatScientificNotation.apply(void 0, _toConsumableArray(match.slice(1)));
}
export function scientificNotationToNumber(value) {
  var _parseScientificNotat = parseScientificNotation(value),
    _parseScientificNotat2 = _slicedToArray(_parseScientificNotat, 2),
    mantissa = _parseScientificNotat2[0],
    exponent = _parseScientificNotat2[1];
  return Number("".concat(mantissa, "e").concat(exponent));
}
export function scientificNotationToDecimal(value) {
  var _parseScientificNotat3 = parseScientificNotation(value),
    _parseScientificNotat4 = _slicedToArray(_parseScientificNotat3, 2),
    mantissa = _parseScientificNotat4[0],
    exponent = _parseScientificNotat4[1];
  return new Decimal("".concat(mantissa, "e").concat(exponent));
}
export function toNumber(value) {
  if (isScientificNotation(value)) return scientificNotationToNumber(value);
  return value == null || /^\s*$/.test(value) ? NaN : Number(value);
}
export function toDecimal(value) {
  if (isScientificNotation(value)) return scientificNotationToDecimal(value);
  try {
    return new Decimal(value);
  } catch (_unused) {
    return new Decimal(NaN);
  }
}
function clean(value) {
  if (typeof value == 'string') return value.trim();
  return value;
}